import type {ReactElement} from 'react';
import {Popover} from '@Components/popover/popover';
import {PopoverDefaultAlignment} from '@Components/popover/popover.types';
import {ScheduleForm} from '@Components/schedule-form/schedule-form';
import type {SchedulePopoverProps} from './schedule-popover.types';
import styles from './schedule-popover.module.scss';

export function SchedulePopover({anchorRef, onClose, ...scheduleFormProps}: SchedulePopoverProps): ReactElement {
  return (
    <Popover referenceElementRef={anchorRef} popoverCloseFunction={onClose} alignment={PopoverDefaultAlignment.TOP_END} className={styles.popover} hasAutoPlacement={false}>
      <div className={styles.content}>
        <ScheduleForm {...scheduleFormProps} />
      </div>
    </Popover>
  );
}
